// extracted by mini-css-extract-plugin
export default {"subscriberForm":"styles_subscriberForm__hUa6i"};